// Velocidade medida no navegador de quem usa o PMS, numa amostra de sessões: os $web_vitals do
// posthog-js (LCP, INP, CLS, FCP) e um PageTiming por página, com o tempo da navegação.
//
// A amostra é a sessão do PostHog ($session_id): a mesma sessão fica toda dentro ou toda fora,
// em qualquer aba, e quem fica fora não manda nenhum dos dois eventos. A taxa vem do servidor
// (POSTHOG_WEB_VITALS_SAMPLE_RATE, 0 desliga). Os $web_vitals a 100% eram ~30% dos eventos
// cobrados (out/2026).
//
// Por que um evento próprio além dos $web_vitals: o posthog-js manda o buffer de métricas 5 s
// depois da primeira e não manda nada ao sair da página. LCP e INP que chegam no clique que leva
// à próxima página se perdem, justo nas páginas mais curtas. O PageTiming sai quando a aba fica
// oculta ou a página é deixada, direto por sendBeacon.
//
// Chega pelo page_context.js, antes do posthog_init.js. ES5 puro, como o resto do arquivo.
(function (window, document) {
  var PAGE_TIMING = "PageTiming";
  var EVENTS = ["$web_vitals", PAGE_TIMING];

  // FNV-1a de 32 bits: o $session_id é UUIDv7, e o começo dele é o relógio. Sem misturar a string
  // inteira, sessões do mesmo minuto cairiam todas do mesmo lado. Os bits baixos são os que mais
  // mudam com o fim da string, por isso o resto da divisão e não a fração do hash.
  function fraction(text) {
    var hash = 0x811c9dc5;
    for (var i = 0; i < text.length; i++) {
      hash ^= text.charCodeAt(i);
      hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }
    return ((hash >>> 0) % 10000) / 10000;
  }

  function sampled(sessionId, rate) {
    return rate > 0 && typeof sessionId === "string" && sessionId !== "" && fraction(sessionId) < rate;
  }

  // Milissegundos a partir do início visível da página. Página pré-renderizada começa quando o
  // usuário a abre (activationStart), não quando o navegador começou a montá-la.
  function since(value, start) {
    return value > 0 ? Math.round(Math.max(0, value - start)) : null;
  }

  function observe(type, options, callback) {
    if (typeof window.PerformanceObserver !== "function") return;
    options.type = type;
    options.buffered = true;
    try {
      new window.PerformanceObserver(function (list) {
        var entries = list.getEntries();
        for (var i = 0; i < entries.length; i++) callback(entries[i]);
      }).observe(options);
    } catch (_error) {
      // Tipo de entrada que o navegador não conhece: a propriedade fica nula.
    }
  }

  window.posthogPerformance = {
    events: EVENTS,
    sampled: sampled,

    // before_send: false descarta. Evento de desempenho de sessão fora da amostra, ou sem sessão,
    // não sai. O que sai não processa propriedades do perfil. Isto NÃO torna anônimo um id já
    // identificado nem muda sua cobrança: identidade e ligação com sessão/erro/gravação seguem.
    // Não lança: na dúvida, desempenho não sai e o resto segue.
    keep: function (event, rate) {
      try {
        if (!event || EVENTS.indexOf(event.event) === -1) return true;
        if (!sampled(event.properties && event.properties.$session_id, rate)) return false;
        event.properties.$process_person_profile = false;
        return true;
      } catch (_error) {
        return !event || EVENTS.indexOf(event.event) === -1;
      }
    },

    // loaded do posthog-js. Sessão fora da amostra não liga observador nenhum; o before_send
    // confere de novo no envio, porque a sessão pode virar no meio da página.
    watch: function (client, rate) {
      var performance = window.performance;
      if (!performance || typeof performance.getEntriesByType !== "function") return;
      if (!sampled(client.get_session_id(), rate)) return;

      var navigation = performance.getEntriesByType("navigation")[0];
      var start = (navigation && navigation.activationStart) || 0;
      var fcp = null;
      var lcp = null;
      var lcpFinal = false;
      var interaction = null;
      var restored = false;
      var sent = false;

      observe("paint", {}, function (entry) {
        if (entry.name === "first-contentful-paint") fcp = since(entry.startTime, start);
      });
      observe("largest-contentful-paint", {}, function (entry) {
        if (!lcpFinal) lcp = since(entry.startTime, start);
      });
      // Como o web-vitals: o LCP para na primeira interação, o que se pinta depois é resposta a ela.
      var finalizeLcp = function () {
        lcpFinal = true;
      };
      window.addEventListener("keydown", finalizeLcp, { once: true, capture: true });
      window.addEventListener("pointerdown", finalizeLcp, { once: true, capture: true });
      // A interação mais lenta da página. Com menos de 50 interações é o próprio INP.
      observe("event", { durationThreshold: 16 }, function (entry) {
        if (entry.interactionId > 0 && (interaction === null || entry.duration > interaction)) {
          interaction = Math.round(entry.duration);
        }
      });

      function properties() {
        // Volta pelo cache de página (bfcache): a página não foi baixada nem montada de novo.
        if (restored || !navigation) {
          return { navigation_type: restored ? "back_forward_cache" : null, max_interaction_ms: interaction };
        }
        return {
          // navigate, reload, back_forward ou prerender.
          navigation_type: navigation.type || null,
          // navigational-prefetch quando a página veio do prefetch, cache quando veio do cache HTTP.
          // Nulo em navegador sem suporte (Chrome < 121, Safari, Firefox).
          delivery_type:
            typeof navigation.deliveryType === "string" ? navigation.deliveryType || "network" : null,
          prerendered: start > 0,
          ttfb_ms: since(navigation.responseStart, start),
          dom_content_loaded_ms: since(navigation.domContentLoadedEventEnd, start),
          load_ms: since(navigation.loadEventEnd, start),
          fcp_ms: fcp,
          lcp_ms: lcp,
          max_interaction_ms: interaction
        };
      }

      // Sai na hora, com sendBeacon. Ao trocar de página o pagehide vem antes do visibilitychange,
      // e o posthog-js despacha a fila no pagehide dele, registrado antes deste: o que entrasse
      // na fila depois ficaria para trás.
      function send() {
        if (sent) return;
        sent = true;
        client.capture(PAGE_TIMING, properties(), { transport: "sendBeacon" });
      }

      document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === "hidden") send();
      });
      window.addEventListener("pagehide", send);
      window.addEventListener("pageshow", function (event) {
        if (!event.persisted) return;
        restored = true;
        interaction = null;
        sent = false;
      });
    }
  };
})(window, document);
